module.exports = __webpack_public_path__ + "img/windows_black.5dde196d.svg";